// extracted by mini-css-extract-plugin
export default {"open":"Page_open__dtleM","page":"Page_page__aH5um"};